function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestingGhoHatPurple = function SvgRestingGhoHatPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 200,
    viewBox: "0 0 286 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.572 233.727s-1.29-15.288-1.405-25.084c-.146-12.402 1.405-31.665 1.405-31.665-5.366 4.941-11.053 9.536-15.83 15.144-4.778 5.618-8.661 12.452-9.526 20.037-.855 7.579 1.805 15.902 7.73 20.038 5.78 4.028 17.626 1.53 17.626 1.53Z",
    fill: "#fff",
    fillOpacity: 0.75,
    style: {
      fill: "#fff",
      fillOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.12 239.381c.45 3.54 4.13 8.77 7.22 10.56 3.1 1.79 6.55 3.19 8.88 5.9 3.93 4.56 3.54 11.5 1.46 17.15-2.82 7.65-8.35 14.26-15.37 18.39-4.51 2.66-9.66 4.36-13.49 7.92-5.07 4.72-6.95 11.83-9.9 18.1-6.16 13.12-18.22 23.57-32.35 26.81-14.81 3.39-30.6-1.19-43.38-9.42-.89-.57-1.77-1.16-2.63-1.77h-.01c-4.68-3.2-12.08-.78-16.83 2.32-4.76 3.09-8.5 7.55-13.21 10.72-10.64 7.17-25.97 6.43-35.87-1.73-2.92-2.4-5.41-5.36-8.73-7.17-3.31-1.8-7.92-2.07-10.47.71-1.26 1.37-1.86 3.3-3.27 4.51-4.13 3.52-9.96-1.65-12.69-6.34-20.13-34.54-30.45-74.01-32.17-114.04-.99-23.23.91-46.64 5.47-69.38.78-3.91 1.64-7.81 2.6-11.69 5.76-23.49 14.78-46.29 29.11-65.68 16.71-22.6 41.26-40.24 69.02-44.63 27.76-4.39 58.37 6.1 74.51 29.1 11.68 16.66 15.01 38.04 13.25 58.3-1.36 15.73-5.53 31.01-10.31 46.1 3.28 9.68 11.95 17.27 20.44 22.97 8.49 5.7 17.71 10.61 24.68 18.09 6.97 7.48 11.36 18.5 7.74 28.06-.86 2.27-2.13 4.33-3.7 6.14Z",
    fill: "#fff",
    fillOpacity: 0.75,
    style: {
      fill: "#fff",
      fillOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.009 252.812c-4.04-3.69-9.99-6.34-11.59-11.3-.04.02-.07.05-.1.08-3.27 2.28-4.9 3.19-8.48 4.89-3.92 1.86-7.88 3.22-12.26 3.4-.55.02-1.13.04-1.72.07 4.13 1.63 7.95 3.8 11 7.01 6.01 6.33 7.05 18.12-.19 22.99-5.04 3.39-12 2.3-17.35 5.18-6.38 3.44-8.67 11.37-9.71 18.55-1.04 7.17-1.67 14.98-6.48 20.4-5.91 6.66-16.28 7.34-24.84 4.86-8.56-2.48-16.15-7.48-24.44-10.72-8.3-3.23-18.24-4.48-25.71.37-7.99 5.19-11.63 16.34-20.74 19.13-7.18 2.2-14.67-1.82-20.97-5.93-6.29-4.1-13.25-8.65-20.68-7.54-5.84.87-11.15 5.21-17 4.4-4.05-.56-7.43-3.59-9.44-7.15-1.58-2.79-3.99-5.59-5.37-8.6 3.19 8.57 8.86 15.88 13.27 23.12 1.96 3.22 4.47 6.62 8.18 7.29 4.1.75 8.42-2.89 8.38-7.06 8.14 1.54 14.35 5.94 20.96 9.48 6.61 3.54 14.1 6.29 21.5 5.04 14.55-2.46 24.46-19.47 39.2-18.94 11.38 10.01 27.02 15.16 41.95 13.31 14.93-1.85 28.85-10.65 36.92-23.34 4.6-7.24 7.42-15.68 13.24-21.98 8.26-8.94 21.92-12.89 27.07-23.91 3.56-7.6 1.6-17.42-4.61-23.08l.01-.02Z",
    fill: "#BCBBFF",
    fillOpacity: 0.4,
    style: {
      fill: "color(display-p3 .7373 .7333 1)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.187,
    cy: 112.346,
    rx: 7.915,
    ry: 6.574,
    transform: "rotate(11.24 70.187 112.346)",
    fill: "#BCBBFF",
    fillOpacity: 0.4,
    style: {
      fill: "color(display-p3 .7373 .7333 1)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.143,
    cy: 116.98,
    rx: 9.19,
    ry: 7.633,
    transform: "rotate(1.098 152.143 116.98)",
    fill: "#BCBBFF",
    fillOpacity: 0.4,
    style: {
      fill: "color(display-p3 .7373 .7333 1)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72 177.141c4.02-14.86 7.94-34.96 9.66-50.25 1.72-15.29 1.03-31.11-4.2-45.59-6.24-17.29-19.03-32.14-35.22-40.87-16.18-8.73-39.73-10.64-57.61-6.35m86.959 202.68c12.07 6.37 23.67 8.81 35.56 5.72 5.29-1.37 10.57-4.02 13.46-8.66 2.47-3.98 2.87-9.02 1.75-13.57-1.12-4.55-3.64-8.65-6.64-12.25-11.54-13.85-29.21-22.09-36.93-38.38",
    stroke: "#BCBBFF",
    strokeOpacity: 0.4,
    style: {
      stroke: "color(display-p3 .7373 .7333 1)",
      strokeOpacity: 0.4
    },
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.044 98.917c1.663-1.687 3.888-2.718 6.262-2.337 2.381.377 4.174 2.054 5.226 4.177 1.053 2.126 1.438 4.814 1 7.57l-.001.002c-.443 2.762-1.649 5.196-3.314 6.887-1.663 1.689-3.888 2.722-6.261 2.347l-.004-.001c-2.378-.381-4.171-2.057-5.223-4.181-1.054-2.126-1.438-4.814-1-7.575v-.002c.444-2.762 1.65-5.196 3.315-6.887Zm-43.939-2.473c1.618-1.472 3.736-2.328 5.924-1.836 2.19.491 3.743 2.167 4.579 4.191.838 2.028 1.025 4.532.456 7.052-.564 2.523-1.805 4.708-3.428 6.186-1.618 1.474-3.737 2.33-5.924 1.838-2.192-.491-3.744-2.171-4.58-4.197-.837-2.03-1.025-4.536-.455-7.056.564-2.519 1.805-4.702 3.428-6.178Z",
    fill: "#000",
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.994 233.892c-5.797 1.405-12.396 1.547-17.046-1.694-5.926-4.136-8.585-12.46-7.73-20.039.864-7.585 4.747-14.419 9.526-20.036 3.316-3.898 8.94-8.111 14.596-14.016",
    stroke: "#000",
    style: {
      stroke: "#000",
      strokeOpacity: 1
    },
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72 177.142c1.43-4.33 2.86-8.66 4.24-13.02 4.78-15.09 8.95-30.37 10.31-46.1 1.76-20.26-1.57-41.64-13.25-58.3-16.14-23-46.75-33.49-74.51-29.1-27.76 4.39-52.31 22.03-69.02 44.63-14.33 19.39-23.35 42.19-29.11 65.68-.96 3.88-1.82 7.78-2.6 11.69-4.56 22.74-6.46 46.15-5.47 69.38 1.72 40.03 12.04 79.5 32.17 114.04 2.73 4.69 8.56 9.86 12.69 6.34 1.41-1.21 2.01-3.14 3.27-4.51 2.55-2.78 7.16-2.51 10.47-.71 3.32 1.81 5.81 4.77 8.73 7.17 9.9 8.16 25.23 8.9 35.87 1.73 4.71-3.17 8.45-7.63 13.21-10.72 4.75-3.1 12.15-5.52 16.83-2.31m.009-.01c.86.61 1.74 1.2 2.63 1.77 12.78 8.23 28.57 12.81 43.38 9.42 14.13-3.24 26.19-13.69 32.35-26.81 2.95-6.27 4.83-13.38 9.9-18.1 3.83-3.56 8.98-5.26 13.49-7.92 7.02-4.13 12.55-10.74 15.37-18.39 2.08-5.65 2.47-12.59-1.46-17.15-2.33-2.71-5.78-4.11-8.88-5.9-3.09-1.79-6.77-7.02-7.22-10.56",
    stroke: "#000",
    style: {
      stroke: "#000",
      strokeOpacity: 1
    },
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.609 303.172c9.252 11.319 19.096 22.442 31.133 30.743M75.3 323.082c-4.68-7.44-8.6-15.37-11.66-23.61m171.039-10.301a143.057 143.057 0 0 1-45.71-27.23",
    stroke: "#000",
    style: {
      stroke: "#000",
      strokeOpacity: 1
    },
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.08 235.472c6.59 3.81 13.23 7.65 20.42 10.13 7.19 2.48 15.07 3.55 22.45 1.7 5.03-1.26 9.79-4.03 13.17-7.92 1.57-1.81 2.84-3.87 3.7-6.14 3.62-9.56-.77-20.58-7.74-28.06-6.97-7.48-16.19-12.39-24.68-18.09-8.49-5.7-17.16-13.29-20.44-22.97",
    stroke: "#000",
    style: {
      stroke: "#000",
      strokeOpacity: 1
    },
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.359 15.129c.503 2.304-.021 4.96-1.811 6.495-1.792 1.542-5.452 1.585-6.699-.422l-.24.137c-2.147-3.595-4.546-6.894-7.154-9.667-.624-1.966-.317-4.14 1.052-5.689 1.489-1.69 4.132-1.966 6.245-1.175 2.106.788 3.765 2.445 5.208 4.175 1.516 1.816 2.891 3.831 3.399 6.146Z",
    fill: "#E5E5FF",
    style: {
      fill: "color(display-p3 .898 .898 1)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.603 74.604c-.85 16.44-4.98 32.71-11.62 47.73-.56-.81-1.12-1.62-1.7-2.42a192.82 192.82 0 0 0-17.42-21.17l1.01-.95c6.03-11.77 10.79-23.12 12.89-37.37 0-9.92-1.21-16.53-4.3-25.43h.01c12.3 13.55 21.13 29.56 21.13 39.61Z",
    fill: "#BCBBFF",
    style: {
      fill: "color(display-p3 .7391 .7337 1)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.864 98.743a192.83 192.83 0 0 1 17.42 21.17l-.3.21c-5.22-7.28-12.97-12.72-21.6-15.14-8.17-2.29-16.92-1.92-25.09-4.23-15.42-4.34-26.55-17.35-39.73-26.45-11.07-7.63-24.24-12.68-37.68-12.44-13.44.25-31.25 6.66-39.06 17.59-8.68-1.47-14.3-2.98-20.37-8.29-3.23-2.82-5.47-6.52-6.07-9.18-1.01-4.53 3.15-8.48 7.1-10.92 12.91-7.95 28.26-11.44 43.41-11.4h.7c14.92.13 29.68 3.52 43.74 8.5 29.36 10.4 56.12 27.96 77.53 50.57v.01Z",
    fill: "#BCBBFF",
    style: {
      fill: "color(display-p3 .7391 .7337 1)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.464 34.994c3.09 8.9 4.3 15.51 4.3 25.43-2.1 14.25-6.86 25.6-12.89 37.37l-1.01.95c-21.41-22.61-48.17-40.17-77.53-50.57-14.06-4.98-28.82-8.37-43.74-8.5v-.23c8.31-8.18 15.61-18.6 27.91-25.04 23.82-11.57 52.93-11.62 76.73-.09 4.48 2.17 8.95 5.08 13.25 8.47 4.58 3.61 8.97 7.78 12.99 12.2h-.01v.01Z",
    fill: "#E5E5FF",
    style: {
      fill: "color(display-p3 .898 .898 1)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.606 39.856c7.086-8.658 13.598-19.012 25.898-25.452 23.82-11.57 52.93-11.62 76.73-.09 4.48 2.17 8.95 5.08 13.25 8.47 4.58 3.61 8.97 7.78 12.99 12.2 12.3 13.56 18.411 30.382 18.411 43.661 0 16.462-2.261 28.669-8.901 43.689M85.606 39.856c14.92.13 27.668 3.338 41.728 8.318 29.36 10.4 56.12 27.96 77.53 50.57a192.84 192.84 0 0 1 17.42 21.17M85.606 39.856c-.23 0 .23 0 0 0Zm0 0c-15.15-.04-35.833 2.163-45.798 8.318-5.444 3.362-7.91 8.717-7.424 13.82.335 3.511 3.003 7.107 6.233 9.927 6.07 5.31 13.589 7.776 22.269 9.246 7.81-10.93 23.558-19.043 36.998-19.293 13.44-.24 26.61 4.81 37.68 12.44 13.18 9.1 24.31 22.11 39.73 26.45 8.17 2.31 16.92 1.94 25.09 4.23 8.63 2.42 16.68 7.64 21.9 14.92m1.7 2.42c-.56-.81-1.12-1.62-1.7-2.42m1.7 2.42c-.32-.5-1.35-1.93-1.7-2.42m-8.829-108.242c-.624-1.966-.317-4.14 1.052-5.689 1.489-1.69 4.132-1.966 6.245-1.175 2.106.788 3.765 2.445 5.208 4.175 1.516 1.816 2.891 3.831 3.399 6.146.503 2.304-.021 4.96-1.811 6.495-1.792 1.542-5.452 1.585-6.699-.422",
    stroke: "#000",
    style: {
      stroke: "#000",
      strokeOpacity: 1
    },
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.552 31.294c5.173 6.143 7.99 13.733 8.627 18.746.873 6.873.258 13.871-1.467 20.582-2.507 9.754-6.315 18.345-10.837 27.172",
    stroke: "#000",
    style: {
      stroke: "#000",
      strokeOpacity: 1
    },
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.322 25.729a2.997 2.997 0 0 0 1.799 3.837 2.997 2.997 0 0 0 2.037-5.637 2.997 2.997 0 0 0-3.836 1.8Zm7.105 2.566a2.998 2.998 0 0 0 5.639 2.037 2.997 2.997 0 0 0-5.639-2.037Z",
    fill: "#7B7BAC",
    style: {
      fill: "color(display-p3 .4837 .4809 .6755)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.352 29.913c-.025-5.076-3.139-9.812-8.145-11.62-6.429-2.323-13.544 1.062-15.892 7.561-2.348 6.5.96 13.65 7.389 15.974 5.357 1.935 11.19-.092 14.345-4.581l-3.121 8.636",
    stroke: "#7B7BAC",
    style: {
      stroke: "color(display-p3 .4837 .4809 .6755)",
      strokeOpacity: 1
    },
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.682,
    cy: 394.431,
    rx: 103.381,
    ry: 9.191,
    fill: "#000",
    fillOpacity: 0.15,
    style: {
      fill: "#000",
      fillOpacity: 0.15
    }
  }));
};
export default SvgRestingGhoHatPurple;